import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p className="about-text">
            Hi everyone! I’m <span className="purple">Tarun Talan</span> from <span className="purple">Ghaziabad, India</span>. 
            I am currently a B.Tech Computer Science student and working as a <span className="purple">Flutter & Android Developer Intern</span> at Software Incubator (SDC).
          </p>
          <p className="about-text">
            I specialize in building scalable <span className="purple">Mobile Applications</span> and robust <span className="purple">Backend Systems</span>, with a core focus on <span className="purple">Clean Architecture</span>.
          </p>
          <p className="about-text">
            My primary stack includes <span className="purple">Flutter (BLoC, Riverpod)</span>, <span className="purple">Android Native (Kotlin, Jetpack Compose)</span>, and <span className="purple">Spring Boot</span>.
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
